import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from '../services/setupInterceptors';

const initialState = {categories:[]};

export const getCategories= createAsyncThunk(
    "pProperties/getCategories",
    async (_,thunkAPI)=>{
        const {data} = await axiosClient.get("categories");
        return data?.success?data: thunkAPI.rejectWithValue("Error");
    },{
        condition:(_,{getState})=>{
            return  (getState().pProperties.categories.length===0)   
        }
    }
)

const pPropertiesSlice = createSlice({
    name:"pProperties",
    initialState,
    extraReducers: (builder) => {
        builder
        .addCase(getCategories.pending, (state) => {
            state.status = 'loading';
            state.error = null;
        })
        .addCase(getCategories.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.categories = action.payload.data;
        })
        .addCase(getCategories.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        })
    }
})

export default pPropertiesSlice.reducer;